/**
 * Resolved dynamic-param map, provided once by `FunnelApp`. Block renderers
 * read it to substitute `{{param}}` tokens and select `dynamic` variants.
 * Empty object when the funnel has no `dynamic` config.
 */
import { createContext } from "preact";

export const DynamicContext = createContext<Record<string, string>>({});
